<template>
  <div
    :data-tooltip="text"
    class="tooltip-icon-holder"
  >
    <VIcon
      v-if="text"
      size="18"
      class="tooltip-icon"
      icon="mdi-about-outline"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  text: {
    type: String
  },
})
</script>


